import { useCallback, useEffect, useRef, useState } from "react";
import { VerifyService } from "../../service/VerifyService";
import { ResultStatusType } from "../../domain/verification/ResultStatusType";

export const CompleteViewModel = (verificationId: string | undefined) => {
    const [result, setResult] = useState<ResultStatusType>(ResultStatusType.PENDING);
    const [name, setName] = useState<string>("");
    const [failureMessage, setFailureMessage] = useState<string | null>(null);

    const timeoutRef = useRef<number | null>(null);

    const schedule = useCallback((ms: number, fn: () => void) => {
        if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(fn, ms);
    }, []);

    const getResult = useCallback(async () => {
        if (!verificationId) return;

        const token = localStorage.getItem("next-step");
        if (!token) {
            schedule(1000, getResult);
            return;
        }

        try {
            const response = await VerifyService.getInstance().getResult(verificationId);

            if (response.result === ResultStatusType.PENDING) {
                schedule(5000, getResult);
            } else {
                localStorage.removeItem("next-step");
                setResult(response.result);
                setName(response.name);
                setFailureMessage(response.failureMessage);
            }
        } catch (e) {
            schedule(5000, getResult);
        }
    }, [verificationId, schedule]);

    useEffect(() => {
        getResult();
        return () => {
            if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
        };
    }, [getResult]);

    return { result, name, failureMessage };
};